import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (ALL-5710). This route rendered authored fixtures from data/mock.ts and
// called no API: every service, deployment, user and setting on it was invented, and
// its actions only raised "Local preview only" toasts. It says so plainly until a
// real backend route exists (context/page_pipeline/BOARD.md).
export default function AdminOrgPage() {
  return (
    <DeferredPage
      nav={{ kind: "header", title: "Organization setup", subtitle: "Activate the first administrator, set up the organization, branding and readiness." }}
      state={{
        title: "Organization setup is not available in this environment yet",
        description: "Organization bootstrap has no backend flow in this environment yet, so nothing on this page was or can be saved. Invite administrators from Invite user.",
      }}
    />
  );
}
